import React from 'react';
import {Box, Link, Typography} from '@mui/material';
import {DownloadStagedImportFile, StagedImportFileSection} from './StagedImportFileDownload';

interface IProps {
    requestId: number;
    hasStagedSalaries: boolean;
}

export const StagedImportFileLinks: React.FC<IProps> =
    ({
         requestId,
         hasStagedSalaries
     }) => {

        const downloadLink = (section: StagedImportFileSection, label: string) => (
            <Link
                component="button"
                type="button"
                onClick={() => DownloadStagedImportFile(requestId, section)}
                underline="always"
                color="primary"
                sx={{cursor: 'pointer', typography: 'caption'}}>
                {label}
            </Link>
        );

        return (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center'}}>
                <Typography variant="caption" fontWeight="bold" color="secondary">
                    Import file
                </Typography>
                {downloadLink('people', 'Download people (CSV)')}
                {hasStagedSalaries && downloadLink('salaries', 'Download salaries (CSV)')}
            </Box>
        );
    };
